module.exports = __webpack_public_path__ + "static/media/GS-create-ic_80x80.d41e2bbc.png";